import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role, requireAdmin }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 text-center font-serif text-2xl">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  if (requireAdmin) {
    // Trust the backend-provided `is_admin` flag — single source of truth is
    // the ADMIN_EMAIL env on the server. Prevents hardcoded-email drift from
    // orphaning the admin UI whenever the admin address changes.
    if (!user.is_admin) return <Navigate to="/" replace />;
  }
  return children;
}
